module.exports = __webpack_public_path__ + "static/media/suppliers.8097c579.svg";